import { Link } from "react-router-dom";

export default function NotFound() {
    return (
        <div
            data-testid="page-404"
            className="min-h-screen flex items-center justify-center bg-coal-900 px-6 pt-32 pb-20"
        >
            <div className="text-center max-w-xl">
                <div className="font-display text-9xl font-bold text-ember tabular tracking-tighter">
                    404
                </div>
                <h1 className="mt-6 font-display text-3xl font-bold uppercase tracking-tight text-white">
                    Off the trade route.
                </h1>
                <p className="mt-4 text-zinc-400 leading-relaxed">
                    The page you tried to reach didn't make port. Let's get you
                    back to the main desk.
                </p>
                <Link
                    to="/"
                    className="inline-block mt-10 bg-ember hover:bg-ember-hover text-white px-8 py-4 font-bold tracking-[0.18em] uppercase text-sm transition-colors"
                >
                    Back to Home
                </Link>
            </div>
        </div>
    );
}
